import { createSlice } from "../helper";
import * as ObjectExtensions from "../../utils/CoreExtensions/ObjectExtensions";
import { updateOthersNotesDetails } from "./helpers/agendaNoteHelper";

// Structure = {
//   [meeting_occurrence_id]: {
//     sectionIds: ,
//     sections: {
//       1 : {
//         id: ,
//         title: ,
//         position: ,
//         canEditGuideSection: ,
//         canDeleteGuideSection: ,
//         agendaItemIds: []
//       }
//     },
//     agendaItems: {
//       1 : {
//         id: ,
//         title: ,
//         position: ,
//         canEditAgendaItem: ,
//         canDeleteAgendaItem:
//       }
//     },
//     purposeProfiles,
//     meetingMembers,
//     createGuideSectionUrl,
//     clearViewGuideTemplatesBannerUrl,
//     clearGuideUrl,
//     shouldShowViewGuideTemplatesBanner,
//   },
//   zeroStateData: {
//     shouldShowStandaloneGuidesZeroState,
//     createBlankAgendaUrl,
//     raisingHandsEmoji,
//     memoEmoji,
//     recommendedGuideTemplates,
//     meetingOccurrenceId
//   },
//   guideWidgetData: {
//     isGuidePresent,
//     guidePath,
//     guideSelectionUrl,
//     attachGuideUrl,
//     markAttachGuideAsViewedUrl,
//     shouldShowAttachGuideNewIndicator,
//     meetingOccurrenceId
//   }
// }

const meetingGuideWidgetsSlice = createSlice({
  name: 'meetingGuideWidgets',
  initialState: {
    trackingData: {},
    isLoading: false
  },
  reducers: {
    setData: (state, action) => {
      state[action.payload.meetingOccurrenceId] = action.payload; 
    },
    updateData: (state, action) => {
      state[action.payload.meetingOccurrenceId] = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId], action.payload);
    },
    setTrackingData: (state, action) => {
      state[action.payload.meetingOccurrenceId].trackingData = action.payload; 
    },
    updateTrackingData: (state, action) => {
      state[action.payload.meetingOccurrenceId].trackingData = action.payload.trackingData; 
    },
    setLoadingState: (state, action) => {
      state[action.payload.meetingOccurrenceId].isLoading = action.payload.isLoading;
    },
    updateShouldShowAttachGuideNewIndicator: (state, action) => {
      state[action.payload.meetingOccurrenceId].shouldShowAttachGuideNewIndicator = action.payload.shouldShowAttachGuideNewIndicator;
    },
    updateShouldShowStandaloneGuidesZeroState: (state, action) => {
      state[action.payload.meetingOccurrenceId].shouldShowStandaloneGuidesZeroState = action.payload.shouldShowStandaloneGuidesZeroState;
    },
    updateShouldShowViewGuideTemplatesBanner: (state, action) => {
      state[action.payload.meetingOccurrenceId].shouldShowViewGuideTemplatesBanner = action.payload.shouldShowViewGuideTemplatesBanner;
    },
    clearSections: (state, action) => {
      state[action.payload.meetingOccurrenceId].sectionIds = [];
      state[action.payload.meetingOccurrenceId].guideSections = {};
    },
    clearAgendaItems: (state, action) => {
      state[action.payload.meetingOccurrenceId].agendaItems = {};
    },
    updateAgendaItems: (state, action) => {
      state[action.payload.meetingOccurrenceId].agendaItems = action.payload.agendaItems;
    },
    updateGuideWidgetData: (state, action) => {
      state[action.payload.meetingOccurrenceId].agendaItems[action.payload.id] = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId].agendaItems[action.payload.id], action.payload);
    },
    updateNoteData: (state, action) => {
      const { meetingOccurrenceId, id, noteData, deletedItem } = action.payload;
      const existingAgendaItem = state[meetingOccurrenceId].agendaItems[id];

      if (Object.prototype.hasOwnProperty.call(noteData, 'agendaItemSelfNoteContent')) {
        state[meetingOccurrenceId].agendaItems[id] = ObjectExtensions.deepMerge(existingAgendaItem, noteData);
      } else {
        updateOthersNotesDetails(existingAgendaItem, noteData, { deleteNote: deletedItem });
      }
    },
    deleteAgendaItem: (state, action) => {
      const { meetingOccurrenceId, agendaItemId, guideSectionId } = action.payload;

      delete state[meetingOccurrenceId].agendaItems[agendaItemId];
      state[meetingOccurrenceId].guideSections[guideSectionId].agendaItemIds =
        state[meetingOccurrenceId].guideSections[guideSectionId].agendaItemIds.filter(
          id => id !== agendaItemId
        );
    },
    addAgendaItem: (state, action) => {
      state[action.payload.meetingOccurrenceId].agendaItems[action.payload.agendaItemId] = action.payload.agendaItemData;
      if (!state[action.payload.meetingOccurrenceId].guideSections[action.payload.guideSectionId].agendaItemIds.includes(action.payload.agendaItemId)) {
        state[action.payload.meetingOccurrenceId].guideSections[action.payload.guideSectionId].agendaItemIds.push(action.payload.agendaItemId);
      }
    },
    lockAgendaItem: (state, action) => {
      const updatedData = { id: action.payload.fieldId, contentLockDetails: action.payload.lockDetails };
      state[action.payload.meetingOccurrenceId].agendaItems[action.payload.fieldId] = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId].agendaItems[action.payload.fieldId], updatedData);
    },
    updateGuideSections: (state, action) => {
      state[action.payload.meetingOccurrenceId].guideSections = action.payload.guideSections;
    },
    addGuideSection: (state, action) => {
      state[action.payload.meetingOccurrenceId].sectionIds = action.payload.sectionIds;
      state[action.payload.meetingOccurrenceId].guideSections[action.payload.id] = action.payload.newSectionData;
      state[action.payload.meetingOccurrenceId].guideSections = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId].guideSections, action.payload.guideSections);
    },
    updateGuideSection: (state, action) => {
      state[action.payload.meetingOccurrenceId].guideSections[action.payload.id] = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId].guideSections[action.payload.id], action.payload);
    },
    deleteGuideSection: (state, action) => {
      const { meetingOccurrenceId, id } = action.payload;

      delete state[meetingOccurrenceId].guideSections[id];
      state[meetingOccurrenceId].sectionIds = state[meetingOccurrenceId].sectionIds.filter(
        sectionId => sectionId !== id
      );
    },
    lockGuideSection: (state, action) => {
      const updatedData = { id: action.payload.fieldId, titleLockDetails: action.payload.lockDetails };
      state[action.payload.meetingOccurrenceId].guideSections[action.payload.fieldId] = ObjectExtensions.deepMerge(state[action.payload.meetingOccurrenceId].guideSections[action.payload.fieldId], updatedData);
    }
  }
});

export const meetingGuideWidgetActions = meetingGuideWidgetsSlice.actions;

export default meetingGuideWidgetsSlice;